import { FileOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Flex, message, Upload } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ShowSection } from '@/components/general/ShowInfo/ShowSection';
import { SERVICE_ORDER_STATUS, ServiceOrder } from '@/model/ServiceOrder/ServiceOrder';
import { useRepositoriesContext } from '@/repositories/RepositoriesContext';

import { getFileNameFromUrl } from './serviceOrderShowHelpers';

interface ServiceOrderShowBillFileProps {
  serviceOrder: ServiceOrder;
  refetch: () => Promise<any>;
}

/**
 * Nota Fiscal (Brasil): a diferencia del Edit eliminado, sube el archivo
 * apenas se selecciona (no hay un submit padre del cual colgarse).
 */
const ServiceOrderShowBillFile = (props: ServiceOrderShowBillFileProps) => {
  const { serviceOrder, refetch } = props;
  const { t } = useTranslation();
  const { serviceOrderRepository } = useRepositoriesContext();
  const [uploading, setUploading] = useState(false);
  const canUpload =
    serviceOrder.status === SERVICE_ORDER_STATUS.COORDINADA ||
    serviceOrder.status === SERVICE_ORDER_STATUS.REALIZADA;
  const handleUpload = async (file: File) => {
    setUploading(true);

    try {
      await serviceOrderRepository.uploadBillFile(serviceOrder.id, file);
      await refetch();
      message.success(t('Nota Fiscal subida correctamente'));
    } catch {
      message.error(t('Ocurrió un error al subir la Nota Fiscal'));
    } finally {
      setUploading(false);
    }

    return false;
  };

  return (
    <ShowSection
      title={t('Nota Fiscal')}
      className="ServiceOrderShowBillFile"
      icon={<FileOutlined />}
    >
      <Flex align="center" gap={8}>
        {serviceOrder.bill_file ? (
          <a href={serviceOrder.bill_file} target="_blank" rel="noopener noreferrer">
            {getFileNameFromUrl(serviceOrder.bill_file, 'nota-fiscal.pdf')}
          </a>
        ) : (
          <span>{t('Todavía no se cargó una Nota Fiscal')}</span>
        )}
        {canUpload && (
          <Upload showUploadList={false} beforeUpload={handleUpload}>
            <Button icon={<UploadOutlined />} size="small" loading={uploading}>
              {serviceOrder.bill_file ? t('Reemplazar') : t('Seleccionar Nota Fiscal (PDF)')}
            </Button>
          </Upload>
        )}
      </Flex>
    </ShowSection>
  );
};

export default ServiceOrderShowBillFile;
